import { render } from "./BaseDialog.vue?vue&type=template&id=5fed266a&scoped=true&bindings={\"show\":\"props\",\"title\":\"props\",\"fixed\":\"props\",\"theme\":\"props\",\"tryClose\":\"options\"}"
import script from "./BaseDialog.vue?vue&type=script&lang=js"
export * from "./BaseDialog.vue?vue&type=script&lang=js"

import "./BaseDialog.vue?vue&type=style&index=0&id=5fed266a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5fed266a"

export default script